import React, { ComponentProps, ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { ChevronDownIcon } from '@components/icons/ChevronDown.icon';
import { PlcFlatRectLoader } from '@components/Loaders/PlcFlatRectLoader.component';
import { Accordion, AccordionDetails, AccordionProps, AccordionSummary } from '@material-ui/core';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';

type ExtendedProps = Omit<ComponentPropsWithRef<'div'>, 'onChange'> & Pick<AccordionProps, 'expanded' | 'onChange'>;

interface Props extends ExtendedProps {
  titleComponent: JSX.Element;
  isJournalPage?: boolean;
  expandIcon?: JSX.Element;
}

const PlcAccordion: FC<PropsWithChildren<Props>> = ({
  className,
  titleComponent,
  expanded,
  onChange,
  children,
  isJournalPage = false,
  expandIcon,
  ...rest
}) => {
  const rootClass = classnames('plc-accordion', className);

  return (
    <div className={rootClass} {...rest}>
      <Accordion elevation={0} expanded={expanded} onChange={onChange} square={true}>
        <AccordionSummary
          expandIcon={
            expandIcon ?? (
              <ChevronDownIcon
                fillColor={isJournalPage ? PlcColor.BLACK : ''}
                stroke={isJournalPage ? PlcColor.BLACK : ''}
                width={20}
              />
            )
          }
        >
          {titleComponent}
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};

const PlcAccordionLoader: FC<
  ComponentPropsWithRef<'div'> & {
    loaderProps?: ComponentProps<typeof PlcFlatRectLoader>;
    uniqueKey: string;
  }
> = ({ className, loaderProps = {}, uniqueKey, ...rest }) => {
  const rootClass = classnames('plc-accordion', className);
  const { height = 58, width = 1, ...restLoaderProps } = loaderProps;
  return (
    <div className={rootClass} {...rest}>
      <PlcFlatRectLoader height={height} uniqueKey={uniqueKey} width={width} {...restLoaderProps} />
    </div>
  );
};

export { PlcAccordion, PlcAccordionLoader };
